import { render, staticRenderFns } from "./AppRelease.vue?vue&type=template&id=098742a0&"
import script from "./AppRelease.vue?vue&type=script&lang=js&"
export * from "./AppRelease.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports